import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import Suppliers from "../../images/suppliers.png"
 

const Supplier = () => {
  const SupplierDoc = {
    title: "Supplier Management",
    description: "This documentation provides guidance on how to effectively manage suppliers within the system, ensuring a smooth and organized supplier relationship.",
    sections: [
      {
        title: "Overview",
        content: "This section outlines the essential functions and capabilities for managing suppliers effectively, allowing you to maintain clear communication and agreements with each supplier."
      },
      {
        title: "Supplier Management",
        content: "Each supplier can be viewed, edited, and verified, allowing for comprehensive oversight of your supplier network.",
        image: Suppliers,
        imageAlt: "Suppliers Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Supplier Dashboard.",
        subsections: [
          {
            title: "Supplier Actions",
            content: "You can easily search for suppliers by their names, making it convenient to locate specific suppliers when needed.",
            steps: [
              "1. Search Functionality: Utilize the search button to quickly locate suppliers by entering their names. This feature streamlines the process of finding the right supplier amidst a potentially large list.",
              "2. VIEW SUPPLIERS: By clicking on a supplier's name, you can access detailed information, including the supplier's name, email address, and other pertinent data. Additionally, you have the ability to update the supplier's agreement terms, switching between markup and commission structures as necessary.",
              "3. VERIFY SUPPLIER: To verify a supplier's credentials, input their generic name along with the applicable agreement term, which could be either a markup or a commission. This verification step ensures that only reputable suppliers are engaged.",
              "4. EDIT USER TYPE: You can change the user type of a supplier, categorizing them as either an advanced supplier or a basic supplier based on their performance and business relationship.",
              "5. EDIT USER: This action is currently disabled but may be enabled in the future for improved user management capabilities."
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...SupplierDoc} />;
};

export default Supplier;
